import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of, catchError } from 'rxjs';
import { PlansManagementService } from '../../../../../shared/services/plans-management.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TncResolver implements Resolve<Observable<any>> {
  constructor(
    private plansManagementService: PlansManagementService,
    private router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this._getTncData();
  }


  _getTncData() {
    return this.plansManagementService.getActivePlan().pipe(switchMap((plan) => {
      return this.plansManagementService.getTnc(plan.spoId).pipe(catchError(() => {
        return this.router.navigate(['main/tnc-error'])
      }))
    }))
  }

}
